/* Lorelia 04.10.2026 – Ortsnamen deutsch bis in den Druck (LS-08).
   teeinblue holt Orte über Mapbox (englisch): „Wien“ wird als „Vienna“ gespeichert und so gedruckt,
   „Rom“ als „Rome“; „Venedig“, „Mailand“, „Lissabon“ werden gar nicht gefunden.
   Dieses Skript (früh im <head>, vor teeinblue und Gestalter 9) ändert NUR die Anfragen/Antworten der
   teeinblue-Ortssuche: deutsche Exonyme werden für die Suche ins Englische übersetzt, die Treffernamen
   in der Antwort zurück ins Deutsche. Kein Eingriff in den teeinblue-DOM. */
(function () {
  if (window.__lrOrtDe) return; window.__lrOrtDe = 1;
  var EN_DE = { 'Cologne': 'Köln', 'Munich': 'München', 'Vienna': 'Wien', 'Nuremberg': 'Nürnberg', 'Hanover': 'Hannover', 'Brunswick': 'Braunschweig',
    'Zurich': 'Zürich', 'Rome': 'Rom', 'Venice': 'Venedig', 'Milan': 'Mailand', 'Florence': 'Florenz', 'Naples': 'Neapel', 'Prague': 'Prag',
    'Warsaw': 'Warschau', 'Copenhagen': 'Kopenhagen', 'Lisbon': 'Lissabon', 'Athens': 'Athen', 'Brussels': 'Brüssel', 'Brussels-Capital': 'Brüssel',
    'Geneva': 'Genf', 'Lucerne': 'Luzern', 'Moscow': 'Moskau', 'Bucharest': 'Bukarest', 'Belgrade': 'Belgrad', 'The Hague': 'Den Haag',
    'Turin': 'Turin', 'Venezia': 'Venedig', 'Milano': 'Mailand', 'Lisboa': 'Lissabon', 'Roma': 'Rom', 'Praha': 'Prag', 'Wien': 'Wien' };
  var DE_EN = { 'venedig': 'Venice', 'mailand': 'Milan', 'lissabon': 'Lisbon', 'genf': 'Geneva', 'warschau': 'Warsaw', 'florenz': 'Florence',
    'neapel': 'Naples', 'athen': 'Athens', 'kopenhagen': 'Copenhagen', 'brüssel': 'Brussels', 'luzern': 'Lucerne', 'moskau': 'Moscow',
    'bukarest': 'Bucharest', 'belgrad': 'Belgrade', 'den haag': 'The Hague' };
  var RE = /gamification-api\.teeinblue\.com\/api\/merchant\/maps\/places\/([^/?#]+)\.json/;
  function anfrage(url) { // deutsches Exonym -> englischer Suchbegriff (nur exakte Treffer)
    var m = String(url).match(RE); if (!m) return url;
    var q; try { q = decodeURIComponent(m[1]); } catch (e) { return url; }
    var en = DE_EN[q.trim().toLowerCase()]; if (!en) return url;
    return String(url).replace(m[1], encodeURIComponent(en));
  }
  function antwort(txt) { // englische Namen -> deutsch (nur Orte, keine Adressen/Straßen)
    try {
      var d = JSON.parse(txt), n = 0;
      (d.features || []).forEach(function (f) {
        var pt = f.place_type || []; if (pt.indexOf('address') >= 0 || pt.indexOf('poi') >= 0) return;
        var de = EN_DE[f.text]; if (!de || de === f.text) return;
        if (f.place_name) f.place_name = String(f.place_name).replace(f.text, de);
        f.text = de; n++;
      });
      return n ? JSON.stringify(d) : txt;
    } catch (e) { return txt; }
  }
  // fetch (Gestalter 9 sucht selbst per fetch)
  var of = window.fetch;
  if (of) window.fetch = function (u, o) {
    var url = typeof u === 'string' ? u : (u && u.url) || '';
    if (!RE.test(url)) return of.apply(this, arguments);
    var neu = anfrage(url);
    return of.call(this, typeof u === 'string' ? neu : new Request(neu, u), o).then(function (r) {
      return r.clone().text().then(function (t) { return new Response(antwort(t), { status: r.status, statusText: r.statusText, headers: r.headers }); });
    });
  };
  // XMLHttpRequest (teeinblue-Kartensuche)
  var X = XMLHttpRequest.prototype, oo = X.open;
  X.open = function (m, u) { var a = [].slice.call(arguments); this.__lrOrt = RE.test(String(u)); if (this.__lrOrt) a[1] = anfrage(u); return oo.apply(this, a); };
  var dT = Object.getOwnPropertyDescriptor(X, 'responseText'), dR = Object.getOwnPropertyDescriptor(X, 'response');
  if (dT && dT.get) Object.defineProperty(X, 'responseText', { configurable: true, get: function () { var t = dT.get.call(this); return this.__lrOrt && this.readyState === 4 ? antwort(t) : t; } });
  if (dR && dR.get) Object.defineProperty(X, 'response', { configurable: true, get: function () {
    var r = dR.get.call(this); if (!this.__lrOrt || this.readyState !== 4) return r;
    if (typeof r === 'string') return antwort(r);
    if (r && typeof r === 'object' && !(r instanceof ArrayBuffer) && !(r instanceof Blob)) { try { return JSON.parse(antwort(JSON.stringify(r))); } catch (e) { } }
    return r; } });
})();
